import { render, staticRenderFns } from "./addy-sign-modal.vue?vue&type=template&id=978b830a&"
import script from "./addy-sign-modal.vue?vue&type=script&lang=js&"
export * from "./addy-sign-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports